<template>
	<div class="page yarn-count-converter">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path d="M5.5,5.5A5.5,5.5,0,1,1,11,11,5.5,5.5,0,0,1,5.5,5.5ZM0,22V19.25c0-3,5-5.5,11-5.5s11,2.48,11,5.5V22Z"/></svg>
					<span class="navigation-title">{{$t('create-user')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form @submit.prevent="create" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="name">{{$t('name')}}*</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="name" id="name" required>
									</div>
									<label for="username">{{$t('username')}}*</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="username" id="username" required>
									</div>
									<label for="email">{{$t('email')}}*</label>
									<div class="element">
										<input type="email" placeholder=" " v-model="email" id="email" required>
										<div class="requirements">{{$t('customer-email-requirements')}}</div>
									</div>
									<label for="password">{{$t('password')}}*</label>
									<div class="element">
										<input type="password" placeholder=" " v-model="password" id="password" required>
									</div>
									<label for="confirm-password">{{$t('confirm-password')}}*</label>
									<div class="element">
										<input type="password" placeholder=" " v-model="confirmPassword" id="confirm-password" required>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
					<div class="container">
						<div class="content">
							<button>{{$t('send')}}</button>
						</div>
					</div>
				</form>
			</section>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
export default {
	data() {
		return {
			name: '',
			username: '',
			email: '',
			password: '',
			confirmPassword: '',
			creationError: false,
		}
	},
	created() {

	},
	methods: {
		create() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			
			this.creationError = false;

			if (!this.name ||
				!this.username ||
				!this.email ||
				!this.password ||
				!this.confirmPassword) {
				this.creationError = true;
				this.$snack.danger(this.$t('compile-all-required-fields'));
			}

			if (this.password !== this.confirmPassword) {
				this.creationError = true;
				this.$snack.danger(this.$t('passwords-does-not-match'));
			}

			if (!this.creationError) {
				const data = {
					name: this.name,
					username: this.username,
					email: this.email,
					password: this.password
				};

				var self = this;
				self.$store.dispatch('registrationRequest', data)
				.then((response) => {
					self.$snack.success(self.$t('created-successfully'));
					self.$router.push(self.$route.query.redirect || {name: 'user', params: {id: response.data.response.insertId}});
				})
				.catch((err) => {
					let resp = err.response;
					if (resp.data.response && resp.data.response.duplicate) {
						switch (resp.data.response.duplicate) {
							case 'name':
								self.$snack.danger(self.$t('duplicate-name-error'));
								break;
							case 'username':
								self.$snack.danger(self.$t('duplicate-username-error'));
								break;
							case 'email':
								self.$snack.danger(self.$t('duplicate-email-error'));
								break;
						}
					} else {
						self.$snack.danger(self.$t('registration-error'));
					}
					self.creationError = true;
					if (navigator.vibrate){
						navigator.vibrate([500]);
					}
				});
			}
		}
	}
}
</script>